// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/easings.css";
import ___CSS_LOADER_ICSS_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/ui.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_2___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.styles__headerMenu___V_MUB {
  display: flex;
  flex-flow: column nowrap;
  width: 280px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #24384c;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  transform: translateX(-280px);
  transition: transform 200ms ${___CSS_LOADER_ICSS_IMPORT_1___.locals["quadInOut"]};
  z-index: 2;
}

/* Menu Logo */
.styles__headerMenuLogo___p0ZQF {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: ${___CSS_LOADER_ICSS_IMPORT_2___.locals["headerHeight"]};
  margin-bottom: 15px;
  padding: 0 30px;
}

.styles__headerTitle___YO8Z6 {
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: white;
}

.styles__headerLogo___heS4A {
  height: 24px;
  margin-right: 10px;
}

/* Menu Section */
.styles__headerMenuSection___H1AeG {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}

.styles__headerMenuLabel___GbvBQ {
  width: 100%;
  margin-bottom: 10px;
  padding-left: 30px;
  font-weight: 400;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
}

/* Menu Items */
.styles__headerMenuItem___YLcTl {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 45px;
  margin-bottom: 1px;
  padding: 0 30px;
  box-shadow: none;
  font-size: 15px;
  font-weight: 500;
  color: white;
  transition: all 0.15s;
}
.styles__headerMenuItem___YLcTl:hover {
    background: #4a90e2;
    box-shadow: none;
  }

.styles__headerMenuItemActive___QK3b6 {
  background: #5a88b2;
  box-shadow: 6px 0 0 0 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]} inset !important;
}

.styles__headerMenuItemActive___QK3b6:hover {
    background: #5a88b2;
    box-shadow: 6px 0 0 0 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]} inset !important;
  }
`, "",{"version":3,"sources":["webpack://./universal/components/Header/HeaderMenu/styles.css"],"names":[],"mappings":"AAOA,cAAc;AACd;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,6BAA6B;EAC7B,wEAAqC;EACrC,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,oDAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AAMvB;AAJE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;AAGF;EACE,mBAAmB;EACnB,mFAA+C;AAMjD;;AAJE;IACE,mBAAmB;IACnB,mFAA+C;EACjD","sourcesContent":["@value colors: \"styles/colors.css\";\n@value gtYellow from colors;\n@value easings: \"styles/easings.css\";\n@value quadInOut from easings;\n@value ui: \"styles/ui.css\";\n@value headerHeight from ui;\n\n/* Container */\n.headerMenu {\n  display: flex;\n  flex-flow: column nowrap;\n  width: 280px;\n  min-height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: #24384c;\n  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n  overflow-y: auto;\n  transform: translateX(-280px);\n  transition: transform 200ms quadInOut;\n  z-index: 2;\n}\n\n/* Menu Logo */\n.headerMenuLogo {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: headerHeight;\n  margin-bottom: 15px;\n  padding: 0 30px;\n}\n\n.headerTitle {\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: white;\n}\n\n.headerLogo {\n  height: 24px;\n  margin-right: 10px;\n}\n\n/* Menu Section */\n.headerMenuSection {\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  margin-bottom: 15px;\n}\n\n.headerMenuLabel {\n  width: 100%;\n  margin-bottom: 10px;\n  padding-left: 30px;\n  font-weight: 400;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Menu Items */\n.headerMenuItem {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 45px;\n  margin-bottom: 1px;\n  padding: 0 30px;\n  box-shadow: none;\n  font-size: 15px;\n  font-weight: 500;\n  color: white;\n  transition: all 0.15s;\n\n  &:hover {\n    background: #4a90e2;\n    box-shadow: none;\n  }\n}\n\n.headerMenuItemActive {\n  background: #5a88b2;\n  box-shadow: 6px 0 0 0 gtYellow inset !important;\n\n  &:hover {\n    background: #5a88b2;\n    box-shadow: 6px 0 0 0 gtYellow inset !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"easings": `"styles/easings.css"`,
	"quadInOut": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["quadInOut"]}`,
	"ui": `"styles/ui.css"`,
	"headerHeight": `${___CSS_LOADER_ICSS_IMPORT_2___.locals["headerHeight"]}`,
	"headerMenu": `styles__headerMenu___V_MUB`,
	"headerMenuLogo": `styles__headerMenuLogo___p0ZQF`,
	"headerTitle": `styles__headerTitle___YO8Z6`,
	"headerLogo": `styles__headerLogo___heS4A`,
	"headerMenuSection": `styles__headerMenuSection___H1AeG`,
	"headerMenuLabel": `styles__headerMenuLabel___GbvBQ`,
	"headerMenuItem": `styles__headerMenuItem___YLcTl`,
	"headerMenuItemActive": `styles__headerMenuItemActive___QK3b6`
};
export default ___CSS_LOADER_EXPORT___;
